import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {apiRequest} from "../api";
import Modal from "react-modal";

const TemplateList = ({universityId, onEdit, refreshKey}) => {
    const [templates, setTemplates] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token"); // Get token for authenticated requests
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [templateToDelete, setTemplateToDelete] = useState(null);

    const handleViewAll = (template) => {
        setSelectedTemplate(template);
    };

    const handleDelete = async (templateId) => {
        try {
            const url = `${apiUrl}/templates/${templateId}/delete`;
            const response = await fetch(url, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) throw new Error("Failed to delete template.");

            setFeedbackMessage("Template deleted successfully.");
            fetchTemplates()
        } catch (error) {
            console.error("Error deleting template:", error);
            setFeedbackMessage("Failed to delete template. Please try again.");
        }

        setTimeout(() => setFeedbackMessage(null), 3000);
    };

    const openDeleteModal = (template) => {
        setTemplateToDelete(template);
        setShowDeleteModal(true);
    };

    const handleCloseModal = () => {
        setSelectedTemplate(null);
    };

    // Function to format dates in Pacific Time
    const formatDate = (date) => {
        if (!date) return "No Date";
        // Parse the date as UTC and format it in Pacific Time
        return new Intl.DateTimeFormat("en-US", {
            timeZone: "America/Los_Angeles",
            year: "numeric",
            month: "short",
            day: "numeric",
        }).format(new Date(date + "Z")); // Append "Z" to ensure it's treated as UTC
    };

    // Fetch templates
    const fetchTemplates = async () => {
        try {
            const endpoint = `${apiUrl}/templates`;
            const data = await apiRequest(endpoint, "GET", null, token);
            setTemplates(data);
            console.log("Fetched templates:", data);
        } catch (error) {
            console.error("Error fetching templates:", error);
            setError("Failed to load templates. Please try again.");
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, [universityId, refreshKey]); // Re-fetch when universityId or refreshKey changes

    if (error) {
        return <p className="text-danger">{error}</p>;
    }

    if (!templates || templates.length === 0) {
        return <p>No Email templates available.</p>; // No tours case
    }

    return (
        <div>
            <div className="tours">
                 {feedbackMessage && (
                <p className={`alert ${feedbackMessage.includes("Failed") ? "alert-danger" : "alert-success"}`}>
                    {feedbackMessage}
                </p>
            )}
            {error && <p className="text-danger">{error}</p>}
                <table>
                    <thead>
                    <tr>
                        <th>TEMPLATE NAME</th>
                        <th>DEFAULT</th>
                        <th>CREATED DATE</th>
                        <th>CREATED BY</th>
                        <th>LAST UPDATED</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    {templates.map((template) => (
                        <tr key={template.id}>
                            <td className="name">{template.name}</td>
                            <td>
                                {template.is_default ? 'Yes' : 'No'}

                            </td>
                            <td>{formatDate(template.created_on)}</td>
                            <td>{template.created_by || "Unknown"}</td>
                            <td>{formatDate(template.last_updated)}</td>
                            <td>
                                <button
                                    className="btn btn-sm btn-edit btn-edit-template"
                                    onClick={() => onEdit(template)}
                                >
                                    Edit
                                </button>
                                &nbsp;
                                <button
                                    className="btn btn-sm btn-view btn-preview-template"
                                    onClick={() => handleViewAll(template)}
                                >
                                    Preview
                                </button>&nbsp;
                                <button className="btn btn-sm btn-danger btn-delete-template" onClick={() => openDeleteModal(template)}>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                {/* Modal for viewing all details */}
                <Modal
                    isOpen={!!selectedTemplate}
                    onRequestClose={handleCloseModal}
                    contentLabel="Submission Details"
                >
                    <h4>Email Template Preview</h4>
                    <br/>
                    {selectedTemplate && (
                        <div
                            dangerouslySetInnerHTML={{__html: selectedTemplate.html_content}}
                        />

                    )}
                    <button className="btn btn-secondary" onClick={handleCloseModal}>
                    Close
                    </button>
                </Modal>

                {/* Delete Confirmation Modal */}
                {showDeleteModal && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999,
                        }}
                    >
                        <DeleteConfirmationModal
                            item={templateToDelete}
                            itemType="email template"
                            onConfirm={handleDelete}
                            onClose={() => setShowDeleteModal(false)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

// Delete Confirmation Modal Component
const DeleteConfirmationModal = ({ item, itemType, onConfirm, onClose }) => {
    const [deleteText, setDeleteText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirm = async () => {
        if (deleteText !== 'DELETE') {
            return;
        }

        setIsDeleting(true);
        try {
            await onConfirm(item.id);
            onClose();
        } catch (error) {
            console.error(`Error deleting ${itemType}:`, error);
        } finally {
            setIsDeleting(false);
        }
    };

    const isDeleteButtonEnabled = deleteText === 'DELETE' && !isDeleting;

    return (
        <div
            style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "8px",
                width: "500px",
                maxHeight: "90vh",
                overflowY: "auto",
                position: "relative",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                    borderBottom: "1px solid #e0e0e0",
                }}
            >
                <h2 style={{ margin: 0, color: '#dc3545' }}>Delete {itemType.charAt(0).toUpperCase() + itemType.slice(1)}</h2>
                <button
                    onClick={onClose}
                    style={{
                        background: "none",
                        border: "none",
                        fontSize: "24px",
                        cursor: "pointer",
                        color: "#666",
                    }}
                >
                    ×
                </button>
            </div>
            
            <div className="modal-body">
                <div style={{ marginBottom: '20px' }}>
                    <p style={{ marginBottom: '15px', color: '#6c757d' }}>
                        You are about to delete the {itemType} <strong>"{item?.name}"</strong>. 
                        This action cannot be undone.
                    </p>
                    
                    <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#fff3cd', 
                        border: '1px solid #ffeaa7',
                        borderRadius: '6px',
                        marginBottom: '20px'
                    }}>
                        <p style={{ margin: 0, color: '#856404' }}>
                            <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                            <strong>Warning:</strong> Deleting this {itemType} will:
                        </p>
                        <ul style={{ margin: '10px 0 0 20px', color: '#856404' }}>
                            <li>Remove the template from all email campaigns</li>
                            <li>Delete all template content and styling</li>
                            <li>Affect any active email campaigns using this template</li>
                        </ul>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                            To confirm deletion, type <strong>DELETE</strong> in the field below:
                        </label>
                        <input
                            type="text"
                            value={deleteText}
                            onChange={(e) => setDeleteText(e.target.value)}
                            placeholder="Type DELETE to confirm"
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                        />
                    </div>
                </div>
            </div>
            
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    padding: "20px",
                    borderTop: "1px solid #e0e0e0",
                }}
            >
                <button 
                    className="btn btn-secondary" 
                    onClick={onClose}
                    disabled={isDeleting}
                >
                    Cancel
                </button>
                <button 
                    className="btn btn-danger" 
                    onClick={handleConfirm}
                    disabled={!isDeleteButtonEnabled}
                    style={{
                        opacity: isDeleteButtonEnabled ? 1 : 0.6,
                        cursor: isDeleteButtonEnabled ? 'pointer' : 'not-allowed'
                    }}
                >
                    {isDeleting ? (
                        <>
                            <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                            Deleting...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-trash" style={{ marginRight: '8px' }}></i>
                            Delete {itemType.charAt(0).toUpperCase() + itemType.slice(1)}
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default TemplateList;